(function () {
  'use strict';

  function debounce(fn, wait) {
    let timer;
    return function debounced(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function formatMoney(amount, currency) {
    const value = Number(amount);
    if (Number.isNaN(value)) return amount;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(value);
    } catch {
      return amount;
    }
  }

  function initPredictiveSearch(overlay) {
    const input = overlay.querySelector('[data-search-input]');
    const results = overlay.querySelector('[data-search-results]');
    const list = overlay.querySelector('[data-search-list]');
    const empty = overlay.querySelector('[data-search-empty]');
    const viewAll = overlay.querySelector('[data-search-view-all]');
    const suggestUrl = overlay.dataset.suggestUrl;
    const currency = overlay.dataset.currency || 'USD';

    if (!input || !results || !list || !suggestUrl) return;

    let activeController = null;

    function clearResults() {
      list.innerHTML = '';
      results.hidden = true;
      empty.hidden = true;
      viewAll.hidden = true;
    }

    function renderProducts(products, query) {
      list.innerHTML = '';

      if (!products.length) {
        results.hidden = false;
        empty.hidden = false;
        viewAll.hidden = true;
        return;
      }

      products.forEach((product) => {
        const item = document.createElement('li');
        item.className = 'inga-search-result';

        const link = document.createElement('a');
        link.className = 'inga-search-result__link';
        link.href = product.url;

        if (product.image) {
          const image = document.createElement('img');
          image.className = 'inga-search-result__image';
          image.src = product.image;
          image.alt = product.title;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 80;
          image.height = 100;
          link.appendChild(image);
        }

        const copy = document.createElement('div');
        copy.className = 'inga-search-result__copy';

        const title = document.createElement('p');
        title.className = 'inga-search-result__title';
        title.textContent = product.title;

        const price = document.createElement('p');
        price.className = 'inga-search-result__price';
        price.textContent = formatMoney(product.price, currency);

        copy.appendChild(title);
        copy.appendChild(price);
        link.appendChild(copy);
        item.appendChild(link);
        list.appendChild(item);
      });

      results.hidden = false;
      empty.hidden = true;
      viewAll.hidden = false;
      viewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    }

    const fetchResults = debounce(async (query) => {
      const trimmed = query.trim();

      if (!trimmed.length) {
        clearResults();
        return;
      }

      if (activeController) activeController.abort();
      activeController = new AbortController();

      const url = new URL(`${suggestUrl}.json`, window.location.origin);
      url.searchParams.set('q', trimmed);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      try {
        const response = await fetch(url.toString(), {
          signal: activeController.signal,
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error('Search request failed');

        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        renderProducts(products, trimmed);
      } catch (error) {
        if (error.name === 'AbortError') return;
        clearResults();
      }
    }, 220);

    input.addEventListener('input', (event) => {
      fetchResults(event.target.value);
    });

    overlay.addEventListener('transitionend', () => {
      if (!overlay.classList.contains('is-open')) clearResults();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-predictive-search]').forEach(initPredictiveSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
